import React, { useState } from 'react'

import Layout from 'components/layouts/signIn'
import { META } from '.config/meta'
import SignInComponent from 'components/ums/signIn'

export default function SignIn () {
  const [loading, setLoading] = useState(false)

  return (
    <Layout sTitle="Sign In" title={META.signInBusiness.title} description={META.signInBusiness.description} path={META.signInBusiness.path} loading={loading}>
      <SignInComponent userType="business" setLoading={setLoading} />
    </Layout>
  )
}
